import * as fromRouter from '@ngrx/router-store';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { Params, UrlSegment } from '@angular/router';
import { flatten } from 'lodash';
import { selectCabinet } from '../cabinet/cabinet.selectors';

export const selectRouter = createFeatureSelector<fromRouter.RouterReducerState>('router');

export const {
  selectQueryParams,
  selectQueryParam,
  selectRouteParams,
  selectRouteParam,
  selectRouteData,
  selectUrl
} = fromRouter.getSelectors(selectRouter);

export const selectAllSegments = createSelector(
  selectRouter,
  router => {
    if (!router) {
      return [] as UrlSegment[];
    }
    let activatedRoute = router.state.root;
    let urlPath = [activatedRoute.url];
    while (activatedRoute.firstChild) {
      activatedRoute = activatedRoute.firstChild;
      urlPath = [
        ...urlPath,
        activatedRoute.url
      ];
    }
    return flatten(urlPath);
  }
);

export const selectAllParams = createSelector(
  selectRouter,
  router => {
    if (!router) {
      return {} as Params;
    }
    let activatedRoute = router.state.root;
    let allParams = activatedRoute.params;
    while (activatedRoute.firstChild) {
      activatedRoute = activatedRoute.firstChild;
      allParams = {
        ...allParams,
        ...activatedRoute.params
      };
    }
    return allParams;
  }
);

export const selectStorageBasePath = createSelector(
  selectAllParams,
  selectCabinet,
  (params, cabinet) => {
    if (!cabinet.id) {
      return '';
    }
    if (!params.patientId) {
      return `Cabinets/${cabinet.id}`;
    }
    return `Cabinets/${cabinet.id}/Patients/${params.patientId}`;
  }
);

export const selectStorageCabinetBasePath = createSelector(
  selectCabinet,
  cabinet => {
    if (!cabinet.id) {
      return '';
    }
    return `Cabinets/${cabinet.id}`;
  }
);
